// extracted by mini-css-extract-plugin
export default {"container":"oA-z","dimension":"pA-z","dimensionLabels":"qA-z"};